import React from 'react';
import VerticalFarmTower from './VerticalFarmTower';
import { ParBadge, SpectrumBar, FeatureBadges } from './Landing';

// Vertical farm page (added 24 Oct 2026). Route: /farm. Holds the animated tower moved off the home page.
const shelves = [
  { nm: '660 nm', colour: '#e91e3c', crop: 'Tomatoes', note: 'Deep red drives flowering and fruit set.' },
  { nm: '450 nm', colour: '#2563eb', crop: 'Lettuce', note: 'Blue keeps leaves compact and thick.' },
  { nm: '380 nm', colour: '#9333ea', crop: 'Basil', note: 'UV-A raises aroma oils and pest resistance.' },
  { nm: '630 nm', colour: '#ef4444', crop: 'Peppers', note: 'Red sits at the photosynthesis peak.' },
  { nm: '430 nm', colour: '#7c3aed', crop: 'Microgreens', note: 'Royal blue matches chlorophyll-a absorption.' },
];

export default function Farm() {
  console.log('[Farm] render');
  return (
    <div className="landing-root farm-root">
      <header className="visuals-header">
        <a href="/" className="visuals-back">&larr; AgriVoLED home</a>
        <div className="farm-badge"><ParBadge /></div>
        <h1>The Vertical Farm</h1>
        <p>Five shelves, five light recipes, one footprint. Each LED bar is tuned to the crop beneath it.</p>
        <div className="farm-spectrum"><SpectrumBar /></div>
      </header>
      <section className="farm-layout">
        <div className="farm-tower">
          <div className="vf-glow-bg"/>
          <VerticalFarmTower />
        </div>
        <div className="farm-shelves">
          {shelves.map((s, i) => (
            <div key={i} className="farm-shelf" style={{ borderLeftColor: s.colour }}>
              <span className="farm-nm" style={{ color: s.colour }}>{s.nm}</span>
              <strong>{s.crop}</strong>
              <span>{s.note}</span>
            </div>
          ))}
          <p className="farm-note">Water drips down the stack and is recovered at the base. The whole tower runs on DC from the perovskite canopy, so no inverter sits between the sun and the LEDs.</p>
        </div>
      </section>
      <section className="section farm-badges">
        <div className="section-header">
          <h2 className="section-title gradient-text-green">What the System Does</h2>
        </div>
        <FeatureBadges />
      </section>
      <footer className="landing-footer">
        <div className="footer-spectrum"/>
        <div className="footer-inner">
          <span className="footer-name">Agri<span>VoLED</span></span>
          <div className="footer-links"><a href="/visuals">Visuals</a><a href="/">Home</a></div>
        </div>
      </footer>
    </div>
  );
}
